// PartiallyDisbursedHistory.jsx
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function PartiallyDisbursedHistory({
  open,
  onClose,
  disbursedDetails,
}) {
  const rows = disbursedDetails ? JSON.parse(disbursedDetails) : [];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ className: "rounded-lg w-[90%] sm:w-[650px]" }}
    >
      <DialogTitle className="flex justify-between items-center font-semibold text-gray-800">
        Disbursed History
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="bg-gray-100 text-gray-700">
              <th className="border border-gray-300 px-3 py-2 text-left">#</th>
              <th className="border border-gray-300 px-3 py-2 text-left">
                Sub Types
              </th>
              <th className="border border-gray-300 px-3 py-2 text-left">
                Amount
              </th>
              <th className="border border-gray-300 px-3 py-2 text-left">
                Remark
              </th>
              <th className="border border-gray-300 px-3 py-2 text-left">
                Date & Time
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((item, index) => (
              <tr key={index} className="even:bg-gray-50">
                <td className="border border-gray-300 px-3 py-2">
                  {index + 1}
                </td>
                <td className="border border-gray-300 px-3 py-2">
                  {item.subTypes || "-"}
                </td>
                <td className="border border-gray-300 px-3 py-2">
                  {item.amount}
                </td>
                <td className="border border-gray-300 px-3 py-2">
                  {item.remark}
                </td>
                <td className="border border-gray-300 px-3 py-2">
                  {new Date(item.date)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, "/") +
                    " " +
                    new Date(item.date).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </DialogContent>
    </Dialog>
  );
}
